module.exports = __webpack_public_path__ + "static/media/patientFiLogo.06a71dd8.svg";